<template>
    <div class="edit">
        <el-dialog title="用户" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="600px" @close="dialogFormVisible">
            <el-form ref="form" size="small" :model="form">

                <el-form-item label="商家接收微信模板消息用户" :label-width="formLabelWidth" :rules="[{ required: true, message: '请输入绑定用户id' }]" prop="user_id">
                    <el-input v-model="form.user_id" type="number" placeholder="请输入用户id" class="max-w460"></el-input>
                    <p class="gray">请在商城小程序个人中心查看用户ID</p>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible">取 消</el-button>
                <el-button type="primary" :disabled="submit_loading" @click="edit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
    import Upload from "@/components/file/Upload";
    export default {
        props: [],
        components: {
            /*图片上传*/
            Upload: Upload,
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: "120px",
                /*是否显示*/
                dialogVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                form: {
                    user_id: "",
                    is_delete: "",
                },
            };
        },
        created() {
        },
        methods: {

            showDialog (row) {
                this.dialogVisible = true;
                if (row !== undefined){
                    //赋值给表单
                    this.form = JSON.parse(JSON.stringify(row));
                }
            },
            /*修改*/
            edit() {
                let self = this;
                let params = this.form;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        self.submit_loading = true;
                        SettingApi.wxMsgUser.edit(params, true)
                            .then((res) => {
                                self.submit_loading = false;
                                self.$message.success(res.msg);
                                self.dialogVisible = false;
                                self.$emit("closeDialog");
                            })
                            .catch((error) => {
                                self.submit_loading = false;
                            });
                    }
                });
            },

            /*关闭弹窗*/
            dialogFormVisible(e) {
                //重置表单的值
                this.resetFormFieldsData();
                this.$refs.form.resetFields()
                this.dialogVisible = false;
            },

            resetFormFieldsData() {
                let form = JSON.parse(JSON.stringify(this.form))
                Object.keys(form).forEach((k) => {
                    switch (typeof form[k]) {
                        case 'object':
                            if(Array.isArray(form[k])) {
                                form[k] = []
                            }else if(form[k]===null) {
                                form[k] = null
                            }else{
                                form[k] = {}
                            }
                            break
                        case 'bigint':
                            form[k] = 1
                            break
                        case 'number':
                            form[k] = 0
                            break
                        case 'string':
                            form[k] = ''
                            break
                        default:
                            break
                    }
                    // eslint-disable-next-line no-unreachable
                    if (this.formDefaultValues !== undefined && this.formDefaultValues[k] != undefined) {
                        form[k] = this.formDefaultValues[k]
                    }
                })
                this.form = form
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setting/wxmsguser/Edit.vue